import {
    WithStyles,
    withStyles,
    Button,
    Grid,
    Card,
    CardHeader,
    IconButton,
    Typography,
    Collapse,
    CardContent,
    FormControlLabel,
    Checkbox,
    TextField,
    MenuItem,
  } from "@material-ui/core";
  // import MyPATDropDown from '../../common/MyPATDropDown';
  import PerfectScrollbar from 'react-perfect-scrollbar';
  import cx from 'classnames';
  import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../styles";
import MyPATDateRange from "../../common/MyPATDateRange";
import { MyPATDropdown } from "../../common";
import  { contentRequestActions }  from "../reducers/contentRequestReducer.js";
import {
  setDateFilter
} from '../actions/contentRequestActions'
import { bindActionCreators } from 'redux';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange, DateRangePicker } from 'react-date-range';

  interface CR_DateProps extends WithStyles<typeof userStyles> {
    dateFilter: any,
    setDateFilter: Function,
    activeTab: string
  }
  
  interface CR_DateState {
    expandedFilter: boolean;
    filterItems: Array<string>;
    startDate: null,
    endDate: null,
    type: string,
    label: string,
    dateFilterState: any,
    showDateRange: boolean
}

// const DateTypeMap: { [key: string]: string } = {
//   "Request Creation date": "create", 
//   "Request Start date": "start", 
//   "Request End date": "due"
// }

const DateFilterTypes = [{ label: 'Request Creation date', value: 'create' }, { label: "Request Start date", value: 'start' }, { label: "Request End date", value: 'end' }]
  
  class CR_Date extends Component<CR_DateProps, CR_DateState> {
    constructor(props:CR_DateProps){
		super(props);
		this.state = {
            expandedFilter: true,
            filterItems: ["Important and urgent", "Not important but urgent",  "Important but not urgent", "Not important and not urgent"],
            startDate: null,
            endDate: null,
            type: 'Select Date Type',
            label:'Select Date Type',
            showDateRange: false,
            dateFilterState: [
              {
                startDate: new Date(),
                endDate: null,
                key: 'selection'
              }
            ]
        };
    }  
    // componentDidMount() {
    //     const userD = ACLService.getUserDetailsFromStorage();
    //     this.setState({userDetails: userD});     
    // }

    filterExpandClick = (value: any) => {
		this.setState({
			expandedFilter: !this.state.expandedFilter
		})
    }

    setDateFilter = (item: any) => {
      this.setState({
        dateFilterState: [item.selection]
      })
      this.props.setDateFilter({
        from: item.selection.startDate,
        to: item.selection.endDate,
        type: this.state.type,
        activeTab: this.props.activeTab
      })
    }

    selectType = (selected: any) => {
      this.setState({
        type: selected.value,
        label: selected.label
      })
    }
    
    handleDateRangeBox = () => {
      this.setState({showDateRange: !this.state.showDateRange});
    }

    getDropDownItems = () => {
      return DateFilterTypes.map(({ label }) => {
        return label;
      })
    }

    handleDateFilterChange = (type: string) => {
      // this.selectType(DateTypeMap[type]
      const value = DateFilterTypes.forEach((dateType:any) => {
        if(dateType.label === type){
          this.selectType(dateType);
        }
      })
      // return DateFilterTypes.find(({ value }) => value === type)
    }
    
    render() {
      const {classes} = this.props;
      const {expandedFilter, filterItems, showDateRange} = this.state;
      return (
        <Card classes={{root: classes.customCard}} elevation={0}>
          <CardHeader
            action={
              <>
                <div className={classes.marginTop12}>
                  <IconButton
                    className={cx(classes.expand, {
                      [classes.expandOpen]: !expandedFilter
                    })}
                    onClick={(e) => this.filterExpandClick(e.target)}
                    aria-expanded={true}
					aria-label="show more"
                  >
                    <ExpandMoreIcon fontSize="small" height="1.5em" />
                  </IconButton>
                </div>
              </>
            }
            title={
              <Typography component="h6" variant="body1">
                Date
              </Typography>
            }
            className={classes.cardHeader}
          />
          <Collapse in={expandedFilter} classes={{container: classes.epansionPanelBody}} timeout="auto" unmountOnExit>
            {/* <CardContent className={cx(classes.scrollBarX, classes.collapsibleContainer, 'crDateCollapse')}> */}
                  <Grid container>
                      <Grid item xs={12} className="dropdownPosition">
                          <MyPATDropdown 
                          placeholder="Select Request Date"
                          dropdownItems={this.getDropDownItems()}
                          selectedItem = {this.state.label}
                          onChange={this.handleDateFilterChange}
                          />
                           {/* <TextField
                              select
                              // className={classNames(classes.margin, classes.textField)}
                              name="type"
                              value={this.state.type}
                              onChange={(e) => this.selectType(e.target.value)}
                              
                              required
                            >
                              <MenuItem value={"none"} disabled>
                                Select Test Type
                              </MenuItem>
                              <MenuItem value={"create"}>
                                Request Creation date
                              </MenuItem>
                              <MenuItem value={"start"}>
                                Request Start date
                              </MenuItem>
                              <MenuItem value={"due"}>
                                 Request End date
                              </MenuItem>
                             
                            </TextField> */}
                        </Grid>
                      </Grid>
                      <Grid className={classes.dateRangeCollapse}
                      onClick={this.handleDateRangeBox}>
                        <Grid container justify="space-between">
                            <Grid item>
                              <Grid className={[classes.paddingLeftSM, "dateLabelPanel"].join(' ')}>
                              <Typography className={classes.dateLabel} align="left">From Date</Typography>
                              <Typography align="left" className={[classes.dateLabel, classes.fontSize16, classes.textCapitalize, classes.blackColor].join(' ')}>Select Start Date</Typography>
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Grid className={[classes.paddingRightSM, "dateLabelPanel"].join(' ')}>
                              <Typography className={classes.dateLabel} align="right">To Date</Typography>
                              <Typography align="right" className={[classes.dateLabel, classes.fontSize16, classes.textCapitalize, classes.blackColor].join(' ')}>Select End Date</Typography>
                              </Grid>
                            </Grid>
                        </Grid>
                      </Grid>
                       { this.state.type !== 'Select Date Type' && showDateRange && 
                      <Grid item xs={12} className={classes.dateRangePicker}> 
                      <Grid container></Grid>                       
                        <Grid>                
                          <DateRange
                            editableDateInputs={true}
                            onChange={item => this.setDateFilter(item)}
                            moveRangeOnFirstSelection={false}
                            ranges={this.state.dateFilterState}
                            // initialFocusedRange={startDate: new Date(), endDate: new Date()}
                          />
                        </Grid>
                      </Grid>
                      }
                  
            {/* </CardContent> */}
          </Collapse>
        </Card>
      );
    }
  }

  const mapStateToProps = (state: any) => ({
    activeTab: state.contentRequestReducer.contentRequestReducer.activeTab,
    dateFilter: state.contentRequestReducer.contentRequestReducer.dateFilter
  });

  const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
      setDateFilter
    },
    dispatch
  );
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(userStyles)(CR_Date));
  